import { render, staticRenderFns } from "./ServiceGeneral.vue?vue&type=template&id=33ce4d76"
import script from "./ServiceGeneral.vue?vue&type=script&lang=js"
export * from "./ServiceGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports